import {UserDefinedPage} from '@models/sidebar/request/user-defined-page';
import {UserDefinedWidget} from '@models/pages/user-defined-page/user-defined-widget';

export class UserDefinedTabSettingsRequest {
  tabDetails: UserDefinedPage = new UserDefinedPage();
  widgets: UserDefinedWidget[] = [];
}
